import React from 'react';

import Group from './Group';

const Divider = () => (
  <Group className="divider__parent divider__container">
    <div className="divider__line" />
  </Group>
);

export default Divider;



// WEBPACK FOOTER //
// ./components/Form/Divider.jsx